module.exports = __webpack_public_path__ + "img/7_56.a4e621d3.png";